/* unplugin-vue-components disabled */import { render } from "./CenterCenter.vue?vue&type=template&id=435f0d96&scoped=true&ts=true"
import script from "./CenterCenter.vue?vue&type=script&lang=ts"
export * from "./CenterCenter.vue?vue&type=script&lang=ts"

import "./CenterCenter.vue?vue&type=style&index=0&id=435f0d96&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-435f0d96"]])

export default __exports__